import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { MissingCreditScoreReason } from '../../../cmg-1003/models';

import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'cmg-clear2-ui-fico-score',
  templateUrl: './fico-score.component.html',
  styleUrls: ['./fico-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tooltip],
})
export class FicoScoreComponent {
  @Input() ficoScore: number | undefined = undefined;
  readonly missingCreditScoreReason = input<MissingCreditScoreReason | undefined>(undefined);
}
